import React, { useState, useEffect } from "react";
import AppDesignSettings from "./AppDesignSettings.jsx";
import ParentGroupSettings from "./ParentGroupSettings.jsx";
import { hexToRgbaObject } from "../../../utils/colors.js";
import { DatePicker, message, Alert, Input, Modal, Divider } from "antd";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  fbUpdateMatchPredictionAndTickets,
  fbGetGroupsForClub,
} from "../../../services/firebaseService/endPoints/group.js";
import { chantApi } from "../../../utils/chantApi.js";
import LoadingModal from "../../commons/LoadingModal.jsx";
import dayjs from "dayjs";
import { startUpdateCountry } from "../../../redux/actions/appData/country.js";
import useCountryStore, { selectCountry } from "../../../store/appData/country.js";
import fakeDispatch from "../../../utils/fakeDispatch.js";
import { afGetSeasons } from "../../../services/apiFootballService/endPoints/seasons.js";
import { afGetLeagues } from "../../../services/apiFootballService/endPoints/leagues.js";
import { afGetClubs } from "../../../services/apiFootballService/endPoints/clubs.js";
import { FInput } from "../../commons/formFields/FInput.jsx";
import { FSelect } from "../../commons/formFields/FSelect.jsx";

import {
  fbRemoveAdminForGroup,
  fbCreateAdminForGroup,
  fbDemoteAdminForGroup,
  fbChangeAdminRole,
  fbGetAdminsForGroup,
} from "../../../services/firebaseService/endPoints/groupAdmins.js";
import Group from "../../../models/superAdmin/Group.js";
import { applicationError } from "../../../redux/actions/error.js";
import generateRegistrationCode from "../../../helperFunctions/generateRegistrationCode.js";
import { continents, countries } from "countries-list";
import { db } from "../../../services/firebaseService/connection.js";
import { rgbToHex } from "../../../helperFunctions/util.jsx";
import { doc, getDoc, updateDoc } from "@firebase/firestore";
import { ChantLogoIcon } from "../../../utils/icons.jsx";
import ChantButton from "../../../CommonComponents/ChantButton/ChantButton.jsx";
import AppIconModal from "../../admin/groupConfig/GroupDesign/AppIconModal.jsx";

// Import app icons
import AppIcon1 from "../../../images/app-icons/1.png";
import AppIcon2 from "../../../images/app-icons/2.png";
import AppIcon3 from "../../../images/app-icons/3.png";
import AppIcon4 from "../../../images/app-icons/4.png";
import AppIcon5 from "../../../images/app-icons/5.png";
import AppIcon6 from "../../../images/app-icons/6.png";
import AppIcon7 from "../../../images/app-icons/7.png";
import AppIcon8 from "../../../images/app-icons/8.png";
import AppIcon9 from "../../../images/app-icons/9.png";
import AppIcon10 from "../../../images/app-icons/10.png";
import AppIcon11 from "../../../images/app-icons/11.png";
import AppIcon12 from "../../../images/app-icons/12.png";
import AppIcon13 from "../../../images/app-icons/13.png";
import AppIcon14 from "../../../images/app-icons/14.png";
import AppIcon15 from "../../../images/app-icons/15.png";
import AppIcon16 from "../../../images/app-icons/16.png";
import AppIcon17 from "../../../images/app-icons/17.png";
import AppIcon18 from "../../../images/app-icons/18.png";
import AppIcon19 from "../../../images/app-icons/19.png";
import AppIcon20 from "../../../images/app-icons/20.png";
import ScreenHeader from "../../../CommonComponents/ScreenHeader/ScreenHeader.jsx";
import logger from "../../../utils/logger.js";
import { withRouter } from "../../../utils/helper.jsx";
import AdminManagement from "./AdminManagement.jsx";

const appIcons = [
  AppIcon1,
  AppIcon2,
  AppIcon3,
  AppIcon4,
  AppIcon5,
  AppIcon6,
  AppIcon7,
  AppIcon8,
  AppIcon9,
  AppIcon10,
  AppIcon11,
  AppIcon12,
  AppIcon13,
  AppIcon14,
  AppIcon15,
  AppIcon16,
  AppIcon17,
  AppIcon18,
  AppIcon19,
  AppIcon20,
];

const groupTypes = [
  "Official Supporters Group",
  "Unofficial Supporters Group",
  "Trust",
  "Club",
].map((type) => ({ type, key: type }));
const groupsToManage = ["All", "Official Groups", "Manual"].map((type) => ({
  type,
  key: type,
}));

const STATUS = [
  "Trial",
  "Onboarding",
  "Nurturing",
  "Active",
  "Risk",
  "Churned",
];
const OWNER = ["Abby", "Birdie", "Justin", "Tom"];

const CreateGroup = (props) => {
  const country = useCountryStore(selectCountry);

  const [leagueList, setLeagueList] = useState([{ name: "Select Season First" }]);
  const [clubList, setClubList] = useState([{ name: "Select League First" }]);
  const [seasonList, setSeasonList] = useState(["Select Country First"]);
  const [countryState, setCountryState] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loadingDocument, setLoadingDocument] = useState(!!props.router.params.id);
  const [editMode, setEditMode] = useState(!!props.router.params.id);
  const [editConfiguration, setEditConfiguration] = useState({
    imageChanged: false,
    path: "",
    admins: [],
    prevEmail1: "",
    prevEmail2: "",
  });
  const [primaryColor, setPrimaryColor] = useState({ r: 7, g: 26, b: 114, a: 1 });
  const [secondaryColor, setSecondaryColor] = useState({ r: 216, g: 0, b: 255, a: 1 });
  const [stripesColor, setStripesColor] = useState({ r: 0, g: 255, b: 87, a: 1 }); // eslint-disable-line no-unused-vars
  const [textPrimaryColor, setTextPrimaryColor] = useState(""); // eslint-disable-line no-unused-vars
  const [textSecondaryColor, setTextSecondaryColor] = useState(""); // eslint-disable-line no-unused-vars
  const [logoList, setLogoList] = useState([]);
  const [transparentLogoList, setTransparentLogoList] = useState([]);
  const [logoFile, setLogoFile] = useState({});
  const [transparentLogoFile, setTransparentLogoFile] = useState({});
  const [logoImgType, setLogoImgType] = useState("regular");
  const [groupName, setGroupName] = useState("");
  const [leagueName, setLeagueName] = useState("");
  const [leagueId, setLeagueId] = useState("");
  const [oldClubId, setOldClubId] = useState("");
  const [clubName, setClubName] = useState("");
  const [clubId, setClubId] = useState("");
  const [renewalDate, setRenewalDate] = useState("");
  const [registrationCode, setRegistrationCode] = useState(generateRegistrationCode()); // eslint-disable-line no-unused-vars
  const [errorInForm, setErrorInForm] = useState({ isError: false, message: "", visible: false });
  const [admins, setAdmins] = useState([{ name: "", email: "", adminType: "" }]);
  const [supportersRegion, setSupportersRegion] = useState("");
  const [regions] = useState(Object.keys(continents).map((key) => ({
    region: continents[key],
    key,
  })));
  const [supportersCountry, setSupportersCountry] = useState("");
  const [countriesState, setCountriesState] = useState([]);
  const [groupType, setGroupType] = useState("");
  const [allowPurchase, setAllowPurchase] = useState(false);
  const [clubPostAllowed, setClubPostAllowed] = useState(false);
  const [isParent, setIsParent] = useState(false);
  const [children, setChildren] = useState([]);
  const [isGroupSelectionManual, setIsGroupSelectionManual] = useState(false);
  const [clubGroups, setClubGroups] = useState([]);
  const [status, setStatus] = useState("");
  const [owner, setOwner] = useState("");
  const [lastMembershipCount, setLastMembershipCount] = useState(0); // eslint-disable-line no-unused-vars
  const [paymentDetails, setPaymentDetails] = useState({ currency: "", stripeAccountId: "" }); // eslint-disable-line no-unused-vars
  const [colors, setColors] = useState([
    "#000000",
    "#B80000",
    "#DB3E00",
    "#FCCB00",
    "#008B02",
    "#006B76",
    "#1273DE",
    "#004DCF",
    "#FFFFFF",
  ]);
  const [showIconModal, setShowIconModal] = useState(false);
  const [selectedAppIconIndex, setSelectedAppIconIndex] = useState(6);
  const [skipLogoWarning, setSkipLogoWarning] = useState(false);
  const [linkedGroupId, setLinkedGroupId] = useState("");
  const [linkedGroupName, setLinkedGroupName] = useState("");
  const [isLinkedGroupValid, setIsLinkedGroupValid] = useState(null);
  const [linkedGroupIdLoading, setLinkedGroupIdLoading] = useState(false);
  const [showDeleteLinkModal, setShowDeleteLinkModal] = useState(false);
  const [deletingLink, setDeletingLink] = useState(false);
  const [aoChapter, setAoChapter] = useState("");
  // Dynamic state fields not in original constructor
  const [unregisteredAdmins, setUnregisteredAdmins] = useState(undefined);
  const [registeredAdmins, setRegisteredAdmins] = useState(undefined);
  const [initialChildren, setInitialChildren] = useState(undefined);
  const [preview, setPreview] = useState(undefined);
  const [season, setSeason] = useState(undefined);

  const handleSubmit = async (e, skipLogoWarningOverride) => {
    e.preventDefault();
    setErrorInForm({
      isError: false,
      message: "",
      visible: false,
    });

    const currentSkipLogoWarning = skipLogoWarningOverride !== undefined ? skipLogoWarningOverride : skipLogoWarning;

    let finalLogo =
      logoImgType === "regular"
        ? logoFile
        : transparentLogoFile;

    if (
      linkedGroupId &&
      linkedGroupId.length > 0 &&
      !isLinkedGroupValid
    ) {
      setErrorInForm({
        isError: true,
        visible: true,
        message: "Linked group is invalid",
      });
      return;
    }

    if (!finalLogo.name && !currentSkipLogoWarning) {
      toast(
        <div>
          <p>Please upload a logo image for the group</p>

          <ChantButton
            onClick={() => {
              toast.dismiss();
              setSkipLogoWarning(true);
              handleSubmit(e, true);
            }}
          >
            Skip
          </ChantButton>
        </div>,
        {
          position: "top-center",
          autoClose: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
        },
      );
      return;
    }

    const stateSnapshot = {
      leagueList, clubList, seasonList, country: countryState, isLoading, loadingDocument,
      editMode, editConfiguration, primaryColor, secondaryColor, stripesColor, textPrimaryColor,
      textSecondaryColor, logoList, transparentLogoList, logoFile, transparentLogoFile, logoImgType,
      groupName, leagueName, leagueId, oldClubId, clubName, clubId, renewalDate, registrationCode,
      errorInForm, admins, supportersRegion, regions, supportersCountry, countries: countriesState,
      groupType, allowPurchase, clubPostAllowed, isParent, children, isGroupSelectionManual,
      clubGroups, status, owner, lastMembershipCount, paymentDetails, colors, showIconModal,
      selectedAppIconIndex, skipLogoWarning, linkedGroupId, linkedGroupName, isLinkedGroupValid,
      linkedGroupIdLoading, showDeleteLinkModal, deletingLink, aoChapter,
      unregisteredAdmins, registeredAdmins, initialChildren, preview, season,
    };

    let data = new Group();
    data.toDataSet({ ...stateSnapshot });
    data = JSON.parse(JSON.stringify(data));

    // Add logo transparency flag
    if (!data.configuration) {
      data.configuration = {};
    }
    data.configuration.isLogoTransparent =
      logoImgType === "transparent";

    if (data.hasError) {
      window.scrollTo(0, 0);
      setErrorInForm({
        isError: true,
        visible: true,
        message: data.hasError.message,
      });
      return;
    } else {
      let promise;
      if (editMode) {
        promise = updateDocument(data);
      } else {
        promise = submitDocument(data);
      }

      promise
        .then(async (content) => {
          if (
            linkedGroupId &&
            linkedGroupId.length > 0 &&
            isLinkedGroupValid &&
            content?.id &&
            content?.id?.length > 0 &&
            content.id !== linkedGroupId
          ) {
            try {
              await updateDoc(doc(db, "group", linkedGroupId), {
                linkedGroupId: [content?.id],
              });
            } catch (error) {
              console.error(
                `Failed to update linkedGroupId for group ${linkedGroupId}:`,
                error,
              );
            }
          }

          // if (!editMode) {
          //   props.dispatch(startAddGroup(content));
          // } else {
          //   props.dispatch(startEditGroup(content));
          // }

          fbUpdateMatchPredictionAndTickets(content?.id, content?.clubId);

          props.router.navigate("/superadmin/groups", { replace: true });
          // props.dispatch(triggerGroupsUpdate())
        })
        .catch((err) => {
          setErrorInForm({ isError: true, visible: true, message: err.message });
          setIsLoading(false);
        });
    }
  };

  // // Create a new record in the database
  const submitDocument = async (data) => {
    try {
      setIsLoading(true);

      let finalLogo =
        logoImgType === "regular"
          ? logoFile
          : transparentLogoFile;
      // Convert file to base64 if exists
      let logoBase64 = null;
      let logoFileName = null;
      let logoFileType = null;

      if (finalLogo && finalLogo instanceof File) {
        logoBase64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(finalLogo);
        });
        logoFileName = finalLogo.name;
        logoFileType = finalLogo.type;
      }

      // Send as JSON
      const payload = {
        data: data,
        admins: admins,
        linkedGroupId: linkedGroupId || null,
        logo: logoBase64,
        logoFileName: logoFileName,
        logoFileType: logoFileType,
      };

      const { data: responseData } = await chantApi.post(
        `${import.meta.env.VITE_GCP_BASE_URL}/superadmin/groups`,
        payload,
      );

      // Create admins after group is created successfully
      if (admins.length > 0) {
        let promises = [];
        admins.forEach((admin) => {
          if (admin.email) {
            promises.push(
              fbCreateAdminForGroup(admin.email, responseData.id, {
                name: admin.name,
                type: admin.adminType,
              }),
            );
          }
        });
        await Promise.all(promises);
      }

      return responseData;
    } catch (error) {
      logger.error("Error creating group:", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  // Update existing record in the database
  const updateDocument = async (data) => {
    try {
      setIsLoading(true);

      // Create admins if needed
      if (admins.length > 0) {
        let promises = [];
        admins.forEach((admin) => {
          if (admin.email) {
            promises.push(
              fbCreateAdminForGroup(admin.email, props.router.params.id, {
                name: admin.name,
                type: admin.adminType,
              }),
            );
          }
        });
        await Promise.all(promises);
      }

      // Update match prediction and tickets if club changed
      if (oldClubId !== clubId) {
        fbUpdateMatchPredictionAndTickets(
          props.router.params.id,
          clubId,
        );
      }

      // Convert logo to base64 if changed
      let logoBase64 = null;
      let logoFileName = null;
      let logoFileType = null;

      if (editConfiguration.imageChanged) {
        const finalLogo =
          logoImgType === "regular"
            ? logoFile
            : transparentLogoFile;

        if (finalLogo && finalLogo instanceof File) {
          logoBase64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(finalLogo);
          });
          logoFileName = finalLogo.name;
          logoFileType = finalLogo.type;
        }
      }

      const payload = {
        data: data,
        logo: logoBase64,
        logoFileName: logoFileName,
        logoFileType: logoFileType,
        imageChanged: editConfiguration.imageChanged,
      };

      const { data: responseData } = await chantApi.put(
        `${import.meta.env.VITE_GCP_BASE_URL}/superadmin/groups/${props.router.params.id}`,
        payload,
      );

      return responseData;
    } catch (error) {
      logger.error("Error updating group:", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendInvite = (email, index, data) => {
    const msg = message.loading(`Sending invite to ${email}`, 0);
    fbCreateAdminForGroup(email, props.router.params.id, {
      name: data.name,
      type: data.type || "admin",
    })
      .then(() => {
        msg();
        message.success(`Invite sent to ${email}`);
      })
      .catch((err) => {
        msg();
        setErrorInForm({ isError: true, visible: true, message: err.message });
        window.scrollTo(0, 0);
      });

    setUnregisteredAdmins((prevUnregisteredAdmins) => {
      let newUnregisteredAdmins = [...prevUnregisteredAdmins];
      newUnregisteredAdmins[index].emailInviteSent = true;
      return newUnregisteredAdmins;
    });
  };

  // Called whenever a new image is uploaded to deleted
  const handleImageChange = ({ fileList }) => {
    let result = {};

    if (logoImgType === "regular") {
      if (fileList.length === 0) {
        result.logoFile = {};
      } else {
        result.logoFile = fileList[0].originFileObj;
      }
      result.logoList = fileList;
    } else {
      if (fileList.length === 0) {
        result.transparentLogoFile = {};
      } else {
        result.transparentLogoFile = fileList[0].originFileObj;
      }
      result.transparentLogoList = fileList;
    }

    if (editMode && !editConfiguration.imageChanged) {
      let newEditConfiguration = Object.assign({}, editConfiguration);
      newEditConfiguration.imageChanged = true;
      setEditConfiguration(newEditConfiguration);
    }

    if (result.logoFile !== undefined) setLogoFile(result.logoFile);
    if (result.logoList !== undefined) setLogoList(result.logoList);
    if (result.transparentLogoFile !== undefined) setTransparentLogoFile(result.transparentLogoFile);
    if (result.transparentLogoList !== undefined) setTransparentLogoList(result.transparentLogoList);
  };

  // Called on form input changes
  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "groupName") setGroupName(value);
    else if (name === "leagueName") setLeagueName(value);
    else if (name === "leagueId") setLeagueId(value);
    else if (name === "clubName") setClubName(value);
    else if (name === "clubId") setClubId(value);
    else if (name === "renewalDate") setRenewalDate(value);
    else if (name === "registrationCode") setRegistrationCode(value);
    else if (name === "aoChapter") setAoChapter(value);
    else if (name === "textPrimaryColor") setTextPrimaryColor(value);
    else if (name === "textSecondaryColor") setTextSecondaryColor(value);
  };

  // Called on form select options changes
  const handleOptionChange = (e) => {
    const newClubId = String(e.target.value);

    if (e.target.name === "clubId") {
      setClubId(newClubId);
      setClubName(e.target.label);

      fbGetGroupsForClub(newClubId).then((docs) => {
        setClubGroups(docs);
      });

      getDoc(doc(db, "clubColors", newClubId)).then((docSnap) => {
        if (docSnap.exists) {
          let data = docSnap.data() || {};
          let newColors = [];
          Object.keys(data).forEach((key) => {
            if (
              key.includes("color") &&
              data[key].r !== "" &&
              data[key].g !== "" &&
              data[key].b !== ""
            ) {
              let color = data[key];
              Object.keys(color).forEach((key) => {
                if (typeof color[key] === "string") {
                  color[key] = parseInt(color[key]);
                }
              });
              let hexColor = rgbToHex(color.r, color.g, color.b);
              newColors.push(hexColor);
            }
          });
          newColors = Array.from(new Set([...newColors, "#ffffff", "#000000"]));
          setColors(newColors);
        }
      });
    } else {
      if (e.target.name === "status") setStatus(newClubId);
      else if (e.target.name === "owner") setOwner(newClubId);
    }
  };

  //
  const handleDateChange = (value) => {
    setRenewalDate(value);
  };

  /* Called on total members change and registeration code change
   *  to accept only numerical values
   */
  const handleNumberChange = (e) => {
    if (!Number.isNaN(Number(e.target.value))) {
      if (e.target.name === "lastMembershipCount") setLastMembershipCount(Number(e.target.value));
    }
  }; // eslint-disable-line no-unused-vars

  // Called on blur of registeration code, to check for valid number of digits i.e - 6
  const checkRegistrationCode = (e) => {
    if (e.target.value > 99999 && e.target.value < 1000000) {
      setErrorInForm({ isError: false, message: "", visible: false });
    } else {
      e.target.focus();
      setErrorInForm({
        isError: true,
        message: "Registration Code Must be Six Digit",
        visible: true,
      });
    }
  }; // eslint-disable-line no-unused-vars

  const uploadAction = (file) => {
    if (logoImgType === "regular") {
      setLogoFile(file);
    } else {
      setTransparentLogoFile(file);
    }
  };

  const handleErrorMessageClose = () => {
    setErrorInForm((prevErrorInForm) => {
      const newErrorInForm = { ...prevErrorInForm };
      newErrorInForm.visible = false;
      return newErrorInForm;
    });
  };

  const handleModalClose = () => {}; // eslint-disable-line no-unused-vars

  const handleColorChange = (color, type) => {
    // Handle both HEX string (from ColorSelector) and RGBA object (from ColorPicker)
    let colorValue = color;

    // If color is a HEX string, convert to RGBA object
    if (typeof color === "string" && color.startsWith("#")) {
      colorValue = hexToRgbaObject(color);
    }

    if (type === "primaryColor") setPrimaryColor(colorValue);
    else if (type === "secondaryColor") setSecondaryColor(colorValue);
    else if (type === "stripesColor") setStripesColor(colorValue);
    else if (type === "textPrimaryColor") setTextPrimaryColor(colorValue);
    else if (type === "textSecondaryColor") setTextSecondaryColor(colorValue);
  };

  const handleCountryChange = (selectedItem) => {
    const { value, label } = selectedItem.target;

    setCountryState(value && value !== "null" ? value : label);
    setSeasonList([]);
    setSeason("");
    setLeagueId("");
    setLeagueName("");
    setClubName("");
    setLeagueList([{ name: "Select Season First" }]);
    setClubId("");
    setClubList([{ name: "Select League First" }]);

    afGetSeasons().then((seasons) => {
      setSeasonList(seasons);
    });
  };

  const handleSeasonChange = (e) => {
    const value = e.target.value;
    setSeason(value);
    setLeagueList([]);
    setLeagueId("");
    setLeagueName("");
    setClubName("");
    setClubId("");
    setClubList([{ name: "Select League First" }]);

    afGetLeagues(countryState, value)
      .then((data) => {
        if (!data || data?.length === 0) {
          data = [{ placeholder: "No Leagues found for this country" }];
        } else {
          data = [...data];
        }

        setLeagueList(data);
      })
      .catch(() => {
        setLeagueList([{ placeholder: "Error loading leagues" }]);
      });
  };

  const handleLeagueChange = (details) => {
    const { label, value } = details.target;
    setLeagueName(label);
    setLeagueId(String(value));
    setClubName("");
    setClubId("");
    setClubList([]);

    afGetClubs(value, season).then((teams) => {
      if (teams) {
        setClubList(teams);
      } else {
        setClubList([{ name: "Select League First" }]);
      }
    });
  };

  const handleAdminChange = (name, value, index) => {
    setAdmins((prevAdmins) => {
      let newAdmins = [...prevAdmins];
      newAdmins[index][name] = value;
      return newAdmins;
    });
  };

  const handleAddAdmin = () => {
    setAdmins((prevAdmins) => {
      let newAdmins = [...prevAdmins];
      newAdmins.push({ name: "", email: "", adminType: "" });
      return newAdmins;
    });
  };

  const handleDemoteRegisteredAdmin = async (userGroupId, name) => {
    let msg = message.loading(`Demoting ${name}`, 0);
    try {
      await fbDemoteAdminForGroup(props.router.params.id, userGroupId);
      msg();
      message.success(`Successfully demoted ${name}`);
      msg = message.loading("Updating admin lists");

      const { registeredAdmins: regAdmins, unRegisteredAdmins } =
        await fbGetAdminsForGroup(props.router.params.id);

      msg();
      setRegisteredAdmins(regAdmins || []);
      setUnregisteredAdmins(unRegisteredAdmins || []);
    } catch (error) {
      msg();
      message.error(`Unable to demote ${name}, contact admin`);
    }
  };

  const handleRemoveUnregisteredAdmin = async (email) => {
    let msg = message.loading(`Removing ${email}`, 0);
    try {
      await fbRemoveAdminForGroup(email, props.router.params.id);
      msg();
      message.success(`Successfully removed ${email}`);
      msg = message.loading("Updating admin lists");

      const { registeredAdmins: regAdmins, unRegisteredAdmins } =
        await fbGetAdminsForGroup(props.router.params.id);

      msg();
      setRegisteredAdmins(regAdmins || []);
      setUnregisteredAdmins(unRegisteredAdmins || []);
    } catch (error) {
      msg();
      message.error(`Unable to remove ${email}, contact admin`);
    }
  };

  const handleTextColorChange = (e) => {
    if (e.target.name === "textPrimaryColor") setTextPrimaryColor(e.target.value);
    else if (e.target.name === "textSecondaryColor") setTextSecondaryColor(e.target.value);
  }; // eslint-disable-line no-unused-vars

  const handleRegionChange = (e) => {
    let newSupportersRegion = e.target.value;
    let availableCountries = Object.keys(countries)
      .filter((key) => countries[key].continent === newSupportersRegion)
      .map((key) => ({ code: key, countryName: countries[key].name }));
    setSupportersRegion(newSupportersRegion);
    setCountriesState(availableCountries);
  };

  const handleSupportersCountryChange = (e) => {
    setSupportersCountry(e.target.value);
  };

  const handleTypeChange = (e) => {
    setGroupType(e.target.value);
  };

  const handleAdminTypeChange = (value, index) => {
    let adminType = value.toLowerCase() !== "admin" ? "parentAdmin" : "admin";
    handleAdminChange("adminType", adminType, index);
  };

  const handleGroupsChange = (e) => {
    if (e.target.value !== "Manual") {
      setChildren([e.target.value]);
      setIsGroupSelectionManual(false);
    } else {
      let newChildren = editMode ? (initialChildren || []) : [];
      setChildren(newChildren);
      setIsGroupSelectionManual(true);
    }
  };

  const handleMenuClick = async (role, id, name) => {
    let msg = message.loading(`Changing role for ${name}`, 0);
    try {
      await fbChangeAdminRole(role, props.router.params.id, id);
      msg();
      message.success(`Successfully changed role for ${name}`);
      msg = message.loading("Updating admin lists");

      const { registeredAdmins: regAdmins, unRegisteredAdmins } =
        await fbGetAdminsForGroup(props.router.params.id);

      msg();
      setRegisteredAdmins(regAdmins || []);
      setUnregisteredAdmins(unRegisteredAdmins || []);
    } catch (error) {
      msg();
      message.error(`Unable to change role for ${name}, contact admin`);
    }
  };

  const getImageSource = () => {
    if (editMode) {
      if (logoList[0]) {
        return logoList[0].url || preview;
      } else {
        return ChantLogoIcon;
      }
    }
    return preview || ChantLogoIcon;
  }; // eslint-disable-line no-unused-vars

  const toggleIconModal = () => {
    setShowIconModal((prev) => !prev);
  };

  const handleModalOpen = (val) => {
    setShowIconModal(val);
  };

  const handleSelectIcon = (iconId) => {
    setSelectedAppIconIndex(iconId);
  };

  const validateLinkedGroupId = async (lgId) => {
    try {
      if (!lgId || lgId.length !== 20) {
        return false;
      }

      const { data } = await chantApi.get(
        `${import.meta.env.VITE_GCP_BASE_URL}/superadmin/groups/${lgId}/details`,
      );

      if (data) {
        return { valid: true, linkedGroupName: data?.groupName };
      }
      return { valid: false, linkedGroupName: "" };
    } catch (error) {
      return { valid: false, linkedGroupName: "" };
    }
  };

  const handleDeleteLink = async () => {
    try {
      setDeletingLink(true);

      const currentGroupId = props.router.params.id;
      const currentLinkedGroupId = linkedGroupId;

      // Remove link from current group
      if (currentGroupId) {
        await updateDoc(doc(db, "group", currentGroupId), {
          linkedGroupId: [],
        });
      }

      // Remove link from linked group
      if (currentLinkedGroupId && currentLinkedGroupId.length === 20) {
        try {
          const linkedGroupDoc = await getDoc(doc(db, "group", currentLinkedGroupId));
          if (linkedGroupDoc.exists()) {
            const linkedGroupData = linkedGroupDoc.data();
            const currentLinkedGroupIds = linkedGroupData.linkedGroupId || [];

            // Remove current group ID from linked group's array
            const updatedLinkedGroupIds = currentLinkedGroupIds.filter(
              (id) => id !== currentGroupId,
            );

            await updateDoc(doc(db, "group", currentLinkedGroupId), {
              linkedGroupId: updatedLinkedGroupIds,
            });
          }
        } catch (error) {
          console.error("Error removing link from linked group:", error);
        }
      }

      // Reset state
      setLinkedGroupId("");
      setLinkedGroupName("");
      setIsLinkedGroupValid(null);
      setShowDeleteLinkModal(false);
      setDeletingLink(false);

      toast.success("Link deleted successfully");
    } catch (error) {
      console.error("Error deleting link:", error);
      toast.error("Failed to delete link");
      setDeletingLink(false);
      setShowDeleteLinkModal(false);
    }
  };

  const handleEditMode = async (groupId) => {
    try {
      let group = new Group();

      const { data } = await chantApi.get(
        `${import.meta.env.VITE_GCP_BASE_URL}/superadmin/groups/${groupId}/details`,
      );
      // }
      group.fromDataSet(data);
      group.groupIndex = data.groupIndex;
      if (group.hasError) {
        setLoadingDocument(false);
        setEditMode(false);
        setAdmins([{ name: "", email: "", adminType: "" }]);
        setClubGroups([]);
        setCountriesState([]);
        setSeasonList([]);
        setLeagueList([{ name: "Select Season First" }]);
        setClubList([{ name: "Select League First" }]);
        setColors(["#ffffff", "#000000"]);
        setLogoList([]);
        setTransparentLogoList([]);
        setUnregisteredAdmins([]);
        setRegisteredAdmins([]);
        setChildren([]);
        setErrorInForm({
          isError: true,
          message: group.hasError.message || "Error loading group data",
          visible: true,
        });

        return;
      } else {
        Promise.all([
          afGetSeasons(),
          afGetLeagues(group.country, group.season),
          afGetClubs(group.leagueId, group.season),
          fbGetAdminsForGroup(groupId),
          fbGetGroupsForClub(group.clubId),
          getDoc(doc(db, "clubColors", group.clubId)).then((docSnap) => {
            if (docSnap.exists) {
              let docData = docSnap.data() || {};
              let newColors = [];
              Object.keys(docData).forEach((key) => {
                if (
                  key.includes("color") &&
                  docData[key].r !== "" &&
                  docData[key].g !== "" &&
                  docData[key].b !== ""
                ) {
                  let color = docData[key];
                  Object.keys(color).forEach((key) => {
                    if (typeof color[key] === "string") {
                      color[key] = parseInt(color[key]);
                    }
                  });
                  let hexColor = rgbToHex(color.r, color.g, color.b);
                  newColors.push(hexColor);
                }
              });
              newColors = Array.from(new Set([...newColors, "#ffffff", "#000000"]));
              setColors(newColors);
            }
          }),
        ])
          .then(async (values) => {
            group.seasonList = values[0];
            group.leagueList = values[1];
            group.clubList = values[2];
            group.registeredAdmins = values[3]?.registeredAdmins || [];
            group.unregisteredAdmins = values[3]?.unRegisteredAdmins || [];
            group.admins = [];
            group.countries = Object.keys(countries)
              .filter(
                (key) => countries[key].continent === data.supportersRegion,
              )
              .map((key) => ({ code: key, countryName: countries[key].name }));
            group.clubGroups = values[4];

            if (group.linkedGroupId && group.linkedGroupId.length > 0) {
              const { valid, linkedGroupName: lgName } =
                await validateLinkedGroupId(group.linkedGroupId);
              if (valid) {
                group.linkedGroupName = lgName;
                group.isLinkedGroupValid = valid;
              } else {
                group.isLinkedGroupValid = false;
              }
            }

            // Spread all group fields into state
            if (group.leagueList !== undefined) setLeagueList(group.leagueList);
            if (group.clubList !== undefined) setClubList(group.clubList);
            if (group.seasonList !== undefined) setSeasonList(group.seasonList);
            if (group.country !== undefined) setCountryState(group.country);
            if (group.logoList !== undefined) setLogoList(group.logoList);
            if (group.transparentLogoList !== undefined) setTransparentLogoList(group.transparentLogoList);
            if (group.logoFile !== undefined) setLogoFile(group.logoFile);
            if (group.transparentLogoFile !== undefined) setTransparentLogoFile(group.transparentLogoFile);
            if (group.logoImgType !== undefined) setLogoImgType(group.logoImgType);
            if (group.groupName !== undefined) setGroupName(group.groupName);
            if (group.leagueName !== undefined) setLeagueName(group.leagueName);
            if (group.leagueId !== undefined) setLeagueId(group.leagueId);
            if (group.clubName !== undefined) setClubName(group.clubName);
            if (group.clubId !== undefined) setClubId(group.clubId);
            if (group.renewalDate !== undefined) setRenewalDate(group.renewalDate);
            if (group.registrationCode !== undefined) setRegistrationCode(group.registrationCode);
            if (group.admins !== undefined) setAdmins(group.admins);
            if (group.supportersRegion !== undefined) setSupportersRegion(group.supportersRegion);
            if (group.supportersCountry !== undefined) setSupportersCountry(group.supportersCountry);
            if (group.countries !== undefined) setCountriesState(group.countries);
            if (group.groupType !== undefined) setGroupType(group.groupType);
            if (group.allowPurchase !== undefined) setAllowPurchase(group.allowPurchase);
            if (group.clubPostAllowed !== undefined) setClubPostAllowed(group.clubPostAllowed);
            if (group.isParent !== undefined) setIsParent(group.isParent);
            if (group.children !== undefined) setChildren(group.children);
            if (group.isGroupSelectionManual !== undefined) setIsGroupSelectionManual(group.isGroupSelectionManual);
            if (group.clubGroups !== undefined) setClubGroups(group.clubGroups);
            if (group.status !== undefined) setStatus(group.status);
            if (group.owner !== undefined) setOwner(group.owner);
            if (group.lastMembershipCount !== undefined) setLastMembershipCount(group.lastMembershipCount);
            if (group.paymentDetails !== undefined) setPaymentDetails(group.paymentDetails);
            if (group.primaryColor !== undefined) setPrimaryColor(group.primaryColor);
            if (group.secondaryColor !== undefined) setSecondaryColor(group.secondaryColor);
            if (group.stripesColor !== undefined) setStripesColor(group.stripesColor);
            if (group.textPrimaryColor !== undefined) setTextPrimaryColor(group.textPrimaryColor);
            if (group.textSecondaryColor !== undefined) setTextSecondaryColor(group.textSecondaryColor);
            if (group.selectedAppIconIndex !== undefined) setSelectedAppIconIndex(group.selectedAppIconIndex);
            if (group.linkedGroupId !== undefined) setLinkedGroupId(group.linkedGroupId);
            if (group.linkedGroupName !== undefined) setLinkedGroupName(group.linkedGroupName);
            if (group.isLinkedGroupValid !== undefined) setIsLinkedGroupValid(group.isLinkedGroupValid);
            if (group.aoChapter !== undefined) setAoChapter(group.aoChapter);
            if (group.season !== undefined) setSeason(group.season);
            if (group.registeredAdmins !== undefined) setRegisteredAdmins(group.registeredAdmins);
            if (group.unregisteredAdmins !== undefined) setUnregisteredAdmins(group.unregisteredAdmins);
            setOldClubId(group.clubId);
            setInitialChildren(
              group.children.includes("All") ||
              group.children.includes("Official Groups")
                ? []
                : group.children,
            );
            setLoadingDocument(false);
          })
          .catch(() => {
            fakeDispatch(
              applicationError({
                message: "Unable to details from football api",
                show: true,
                intensity: "high",
              }),
            );
            props.router.navigate("/superadmin/groups", { replace: true });
          });
      }
    } catch (error) {
      logger.log(error);
      // Set safe default state to prevent render crashes
      setLoadingDocument(false);
      setEditMode(false);
      setAdmins([{ name: "", email: "", adminType: "" }]);
      setClubGroups([]);
      setCountriesState([]);
      setSeasonList([]);
      setLeagueList([{ name: "Select Season First" }]);
      setClubList([{ name: "Select League First" }]);
      setColors(["#ffffff", "#000000"]);
      setLogoList([]);
      setUnregisteredAdmins([]);
      setRegisteredAdmins([]);
      setChildren([]);
      setErrorInForm({
        isError: true,
        message:
          "Error loading group data: " + (error.message || "Unknown error"),
        visible: true,
      });
      setTimeout(() => {
        props.router.navigate("/superadmin/groups");
      }, 100);
    }
  };

  useEffect(() => {
    if (props.router.params.id) {
      handleEditMode(props.router.params.id);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // eslint-disable-next-line no-unused-vars
  const removeAdmin = (idx) => {
    const adminsClone = [...admins];
    adminsClone.splice(idx, 1);
    setAdmins(adminsClone);
  };

  const handleLinkedGroupIdChange = async (e) => {
    const newLinkedGroupId = e.target.value;

    if (e.target.value.length > 20) {
      return;
    }

    setLinkedGroupId(newLinkedGroupId);

    if (
      editMode &&
      props.router.params.id === newLinkedGroupId
    ) {
      toast.error("You cannot link a group to itself");
      return;
    }

    if (!newLinkedGroupId || newLinkedGroupId?.length < 20) {
      return;
    }

    try {
      setLinkedGroupIdLoading(true);
      const { valid, linkedGroupName: lgName } =
        await validateLinkedGroupId(newLinkedGroupId);
      if (valid) {
        setLinkedGroupName(lgName);
        setIsLinkedGroupValid(true);
      } else {
        setIsLinkedGroupValid(false);
      }
    } catch (error) {
      setIsLinkedGroupValid(false);
      logger.error(error);
    } finally {
      setLinkedGroupIdLoading(false);
    }
  };

  const appIconImage =
    appIcons[selectedAppIconIndex] || appIcons[0];

  let groupOptions = (clubGroups || []).map((group) => ({
    id: group.id,
    label: group.groupName,
  }));
  if (editMode) {
    groupOptions = groupOptions.filter(
      (details) => details.id !== props.router.params.id,
    );
  }

  if (!country.isCurrent)
    fakeDispatch(startUpdateCountry());

  let loadingTitle = "",
    loadingMessage = "";
  if (loadingDocument) {
    loadingTitle = "Loading Document";
    loadingMessage = "Fetching data";
  } else if (isLoading) {
    loadingTitle = editMode ? "Updating Group" : "Creating Group";
    loadingMessage = editMode
      ? "Updating content"
      : "Creating new content";
  }

  return (
    <div
      className="mx-md-0 mx-0 border-box border rounded"
      style={{ width: "100%", overflow: "hidden", padding: "12px" }}
    >
      <LoadingModal
        title={loadingTitle}
        message={loadingMessage}
        loading={loadingDocument || isLoading}
      />

      <AppIconModal
        showIconModal={showIconModal}
        handleModalOpen={handleModalOpen}
        handleSelectIcon={handleSelectIcon}
        selectedAppIconIndex={selectedAppIconIndex}
      />

      <Modal
        title="Delete Link Confirmation"
        open={showDeleteLinkModal}
        onOk={handleDeleteLink}
        onCancel={() => setShowDeleteLinkModal(false)}
        okText="Yes, Delete Link"
        cancelText="Cancel"
        okButtonProps={{ danger: true, loading: deletingLink }}
        cancelButtonProps={{ disabled: deletingLink }}
      >
        <p>
          Are you sure you want to delete the link between{" "}
          <strong>{groupName}</strong> and{" "}
          <strong>{linkedGroupName}</strong>?
        </p>
        <p style={{ color: "#666", fontSize: "14px" }}>
          This will remove the connection from both groups.
        </p>
      </Modal>

      {errorInForm?.isError && errorInForm?.visible && (
        <Alert
          message="Error"
          description={errorInForm?.message}
          type="error"
          closable
          // className="mb-3"
          afterClose={handleErrorMessageClose}
        />
      )}

      <ScreenHeader
        title={editMode ? "Edit Group" : "Create Group"}
      />
      <form
        style={{
          padding: "20px 30px",
          backgroundColor: "white",
          marginTop: "2px",
        }}
        onSubmit={handleSubmit}
      >
        <div className="form-group ">
          <div className="col-6">
            <FInput
              value={groupName}
              label="Supporters Group Name"
              onChange={handleInputChange}
              name="groupName"
              placeholder="Footie Mob"
              required
            />
          </div>
        </div>

        <div className="form-group">
          <div className="col-6">
            <FSelect
              label="Supporters' Group Region"
              value={supportersRegion}
              onChange={handleRegionChange}
              placeholder={
                country.isCurrent
                  ? "--Select Region--"
                  : "Loading..."
              }
              dataList={regions || []}
              dataKey="key"
              dataValue="region"
              required
            />
          </div>

          <div className="col-6">
            <FSelect
              label="Supporters' Group Country"
              value={supportersCountry}
              onChange={handleSupportersCountryChange}
              placeholder={
                (countriesState || []).length > 0
                  ? "--Select Country--"
                  : "Loading..."
              }
              dataList={countriesState || []}
              dataKey="code"
              dataValue="countryName"
              required
              disabled={!supportersRegion}
            />
          </div>
        </div>

        <div className="form-group">
          <div className="col-6">
            <FSelect
              label="Club Country"
              value={countryState}
              onChange={handleCountryChange}
              placeholder={
                country.isCurrent
                  ? "--Select Country--"
                  : "Loading..."
              }
              dataList={country.data}
              dataKey="code"
              dataValue="name"
              required
            />
          </div>

          <div className="col-6">
            <FSelect
              label="Season"
              value={season}
              onChange={handleSeasonChange}
              placeholder={
                (seasonList || []).length === 0
                  ? "Loading..."
                  : "--Select Season--"
              }
              dataList={seasonList || []}
              dataKey="season"
              dataValue="season"
              dataOnlyValue
              textCenter
              required
              disabled={!countryState}
            />
          </div>
        </div>

        {/* League */}
        <div className="form-group">
          <div className="col-6">
            <FSelect
              label="League"
              value={leagueName}
              name="leagueId"
              onChange={handleLeagueChange}
              placeholder={
                (leagueList || []).length === 0
                  ? "Loading..."
                  : (leagueList || [])[0]?.placeholder
                    ? (leagueList || [])[0]?.placeholder
                    : "--Select League--"
              }
              dataList={
                (leagueList || []).length === 0
                  ? []
                  : (leagueList || [])[0]?.placeholder
                    ? []
                    : leagueList || []
              }
              dataKey="league_id"
              dataValue="name"
              required
              disabled={!season}
            />
          </div>
          <div className="col-6">
            <FSelect
              label="Club"
              value={clubName}
              name="clubId"
              onChange={handleOptionChange}
              placeholder={
                (clubList || []).length === 0
                  ? "Loading..."
                  : "--Select Club--"
              }
              dataList={clubList || []}
              dataKey="team_id"
              dataValue="name"
              textCenter
              required
              disabled={!leagueId}
            />
          </div>
        </div>

        <div className="form-group">
          <div className="col-6 mb-2">
            <div className="row">
              <label className="col-4">Renewal Date</label>
              <DatePicker
                // defaultPickerValue={renewalDate}
                className="col-8 form-control form-control-sm"
                value={renewalDate}
                onChange={handleDateChange}
                defaultPickerValue={dayjs().endOf("year")}
              />
            </div>
          </div>

          {/* <div className="col-lg-4 col-md-6">
            <FInput
              label="Total Members"
              placeholder="100"
              name="totalMembers"
              value={totalMembers}
              onChange={handleNumberChange}
              required
            />
          </div> */}
        </div>

        {/* Logo */}
        <div className="form-group">
          <div className="col-md-6">
            <FSelect
              label="Group Type"
              value={groupType}
              onChange={handleTypeChange}
              placeholder={!groupType && "--Select Type--"}
              dataList={groupTypes}
              dataKey="key"
              dataValue="type"
              required
            />
          </div>
          <div className="col-md-6">
            <div className="form-group" style={{ display: "flex" }}>
              <label
                className="form-check-label ml-0"
                htmlFor="defaultCheck1"
              >
                Allow group to post to Global Chat Streams?&nbsp;
              </label>
              <div className="flex-center">
                <input
                  style={{ height: "20px", width: "20px", marginLeft: 10 }}
                  type="checkbox"
                  className="form-control-input cursor-pointer"
                  id="defaultCheck1"
                  checked={clubPostAllowed}
                  onChange={(e) => {
                    setClubPostAllowed(e.target.checked);
                  }}
                />
              </div>
            </div>
          </div>
          <div>
            <div className="form-group" style={{ display: "flex" }}>
              <label
                className="form-check-label ml-0"
                htmlFor="defaultCheck1"
              >
                Allow members to purchase giveaway entries?&nbsp;
              </label>
              <div className="flex-center">
                <input
                  style={{ height: "20px", width: "20px", marginLeft: 10 }}
                  type="checkbox"
                  className="form-control-input cursor-pointer"
                  id="defaultCheck1"
                  checked={allowPurchase}
                  onChange={(e) => {
                    setAllowPurchase(e.target.checked);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="col-6">
            <FSelect
              label="Status"
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
              }}
              placeholder={"Status"}
              dataList={STATUS}
              dataOnlyValue={true}
            />
          </div>
          <div className="col-6">
            <FSelect
              label="Owner"
              value={owner}
              onChange={(e) => {
                setOwner(e.target.value);
              }}
              placeholder={"Owner"}
              dataList={OWNER}
              dataOnlyValue={true}
            />
          </div>

          <div className="col-6">
            <FInput
              value={aoChapter}
              label="AO Chapter"
              onChange={handleInputChange}
              name="aoChapter"
            />
          </div>

          <div className="col-6">
            <span>Linked Group ID</span>
            <div
              style={{ display: "flex", gap: "8px", alignItems: "center" }}
            >
              <Input
                maxLength={20}
                disabled={linkedGroupIdLoading}
                loading={linkedGroupIdLoading}
                placeholder="Enter Group ID to link with this group"
                value={linkedGroupId}
                onChange={handleLinkedGroupIdChange}
              />
              {linkedGroupId &&
                linkedGroupId.length > 0 &&
                editMode && (
                  <ChantButton
                    type="default"
                    danger
                    onClick={() =>
                      setShowDeleteLinkModal(true)
                    }
                    disabled={linkedGroupIdLoading}
                    style={{ height: "32px" }}
                  >
                    Remove Link
                  </ChantButton>
                )}
            </div>

            <div style={{ marginLeft: 12 }}>
              {linkedGroupIdLoading ? (
                <p>
                  <i
                    style={{ color: "orange" }}
                    className="fa fa-spinner fa-spin"
                  ></i>{" "}
                  Loading...
                </p>
              ) : linkedGroupName &&
                isLinkedGroupValid ? (
                <p>
                  <strong>Group Name:</strong> {linkedGroupName}{" "}
                  <i style={{ color: "green" }} className="fa fa-check"></i>{" "}
                </p>
              ) : isLinkedGroupValid === false ? (
                <p>
                  <i style={{ color: "red" }} className="fa fa-times"></i>{" "}
                  Group not found
                </p>
              ) : null}
            </div>
          </div>
        </div>

        <ParentGroupSettings
          isParent={isParent}
          setIsParent={(val) => setIsParent(val)}
          childGroups={children}
          setChildGroups={(val) => setChildren(val)}
          isGroupSelectionManual={isGroupSelectionManual}
          groupsToManage={groupsToManage}
          groupOptions={groupOptions}
          handleGroupsChange={handleGroupsChange}
        />

        <AppDesignSettings
          colors={colors}
          logoImgType={logoImgType}
          setLogoImgType={(val) => setLogoImgType(val)}
          logoList={logoList}
          transparentLogoList={transparentLogoList}
          uploadAction={uploadAction}
          handleImageChange={handleImageChange}
          setPreview={(val) => setPreview(val)}
          appIconImage={appIconImage}
          toggleIconModal={toggleIconModal}
          handleColorChange={handleColorChange}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          groupName={groupName}
          preview={preview}
        />

        <AdminManagement
          // New admins props
          admins={admins}
          isParent={isParent}
          groupType={groupType}
          onAdminChange={handleAdminChange}
          onAddAdmin={handleAddAdmin}
          onRemoveAdmin={(index) => {
            const adminsClone = [...admins];
            adminsClone.splice(index, 1);
            setAdmins(adminsClone);
          }}
          onAdminTypeChange={handleAdminTypeChange}
          // Existing admins props (edit mode)
          editMode={editMode}
          registeredAdmins={registeredAdmins}
          unregisteredAdmins={unregisteredAdmins}
          onSendInvite={handleSendInvite}
          onRemoveUnregisteredAdmin={handleRemoveUnregisteredAdmin}
          onMenuClick={handleMenuClick}
        />

        <Divider style={{ margin: "16px 0" }} />

        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "32px" }}
        >
          <ChantButton
            htmlType="submit"
            loading={isLoading}
            disabled={isLoading}
          >
            {editMode ? "Update Group" : "Submit"}
          </ChantButton>
        </div>
      </form>
    </div>
  );
};

export default withRouter(CreateGroup);
